import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const printDefaultState = {
  container: {
    top: 530,
    left: 302,
    show: true,
    size: 50,
    title: "container",
    name: "container",
    identifiyer: "container",
  },
  logo: {
    top: 5,
    left: 214,
    show: true,
    size: 30,
    title: "logo",
    name: "Bill Logo",
    identifiyer: "logo",
  },
  header: {
    top: 21,
    left: 100,
    show: true,
    size: 40,
    title: "DEMO MART",
    name: "Shop Name",
    identifiyer: "header",
  },
  address: {
    top: 75,
    left: 75,
    show: true,
    size: 13,
    title: "DEMO",
    name: "Address",
    identifiyer: "address",
  },
  phonetext: {
    top: 90,
    left: 103,
    show: true,
    size: 13,
    title: "TEL : ",
    name: "Phone Number text",
    identifiyer: "phonetext",
  },
  phone: {
    top: 90,
    left: 137,
    show: true,
    size: 13,
    title: "0434334434",
    name: "Phone Number",
    identifiyer: "phone",
  },
  emailText: {
    top: 104,
    left: 85,
    show: true,
    size: 13,
    title: "EMAIL : ",
    name: "Email Address Text",
    identifiyer: "emailText",
  },
  eamilNumber: {
    top: 104,
    left: 136,
    show: true,
    size: 13,
    title: "DEMO@GMAIL.COM",
    name: "Email Address",
    identifiyer: "eamilNumber",
  },
  date: {
    top: 120,
    left: 15,
    show: true,
    size: 13,
    title: "DATE",
    name: "Date",
    identifiyer: "date",
  },
  time: {
    top: 120,
    left: 81,
    show: true,
    size: 13,
    title: "TIME",
    name: "Time",
    identifiyer: "time",
  },
  orderNo: {
    top: 120,
    left: 238,
    show: true,
    size: 13,
    title: "R: ",
    name: "Order Number Text",
    identifiyer: "orderNo",
  },
  orderNumber: {
    top: 120,
    left: 252,
    show: true,
    size: 13,
    title: "01000257",
    name: "Order Number",
    identifiyer: "orderNumber",
  },
  cashier: {
    top: 120,
    left: 155,
    show: false,
    size: 13,
    title: "C:",
    name: "Cashier Text",
    identifiyer: "cashier",
  },
  cashierName: {
    top: 121,
    left: 168,
    show: true,
    size: 13,
    title: "DEMO DEMO",
    name: "Cashier Name",
    identifiyer: "cashierName",
  },
  seriNo: {
    top: 140,
    left: 2,
    show: true,
    size: 13,
    title: "LN",
    name: "Serial Number Text",
    identifiyer: "seriNo",
  },
  pluNumber: {
    top: 140,
    left: 45,
    show: true,
    size: 13,
    title: "PLU.",
    name: "PLU Text",
    identifiyer: "pluNumber",
  },
  itemCode: {
    top: 140,
    left: 110,
    show: true,
    size: 13,
    title: "ITEM",
    name: "ITEM CODE",
    identifiyer: "itemCode",
  },
  discription: {
    top: 170,
    left: 170,
    show: true,
    size: 13,
    title: "DISCRIPTION",
    name: "item discription Text",
    identifiyer: "discription",
  },
  quantity: {
    top: 155,
    left: 2,
    show: true,
    size: 13,
    title: "QTY",
    name: "Quantity text",
    identifiyer: "quantity",
  },
  rate: {
    top: 155,
    left: 50,
    show: true,
    size: 13,
    title: "RATE",
    name: "Rate text",
    identifiyer: "rate",
  },
  gross: {
    top: 155,
    left: 120,
    show: true,
    size: 13,
    title: "GROSS",
    name: "gross text",
    identifiyer: "gross",
  },
  discount: {
    top: 155,
    left: 200,
    show: true,
    size: 13,
    title: "DIS%",
    name: "discount text",
    identifiyer: "discount",
  },
  netAmount: {
    top: 155,
    left: 240,
    show: true,
    size: 13,
    title: "NET AMT",
    name: "Net Amount Text",
    identifiyer: "netAmount",
  },
  shopingDetail: {
    top: 175,
    left: 2,
    show: true,
    size: 295,
    title: "treatmentDetail",
    name: "Item Details Table",
    identifiyer: "shopingDetail",
  },
  totalDetails: {
    top: 245,
    left: 2,
    show: true,
    size: 295,
    title: "treatmentDetail",
    name: "Total Details Table",
    identifiyer: "totalDetails",
  },
  amountTotal: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "TOTAL",
    name: "Amount Row - Total",
    identifiyer: "amountTotal",
  },
  amountLineDiscount: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "LINE DISCOUNT",
    name: "Amount Row - Line Discount",
    identifiyer: "amountLineDiscount",
  },
  amountTax: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "TAX",
    name: "Amount Row - Tax",
    identifiyer: "amountTax",
  },
  amountBillDiscount: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "BILL DISCOUNT",
    name: "Amount Row - Bill Discount",
    identifiyer: "amountBillDiscount",
  },
  amountNetTotal: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "NET TOTAL",
    name: "Amount Row - Net Total",
    identifiyer: "amountNetTotal",
  },
  amountCard: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "CARD",
    name: "Amount Row - Card",
    identifiyer: "amountCard",
  },
  amountCash: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "CASH",
    name: "Amount Row - Cash",
    identifiyer: "amountCash",
  },
  amountBank: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "BANK",
    name: "Amount Row - Bank",
    identifiyer: "amountBank",
  },
  amountTotalPay: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "TOTAL PAY",
    name: "Amount Row - Total Pay",
    identifiyer: "amountTotalPay",
  },
  amountBalance: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "BALANCE",
    name: "Amount Row - Balance",
    identifiyer: "amountBalance",
  },
  amountPendingPayment: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "PENDING PAYMENT",
    name: "Amount Row - Pending Payment",
    identifiyer: "amountPendingPayment",
  },
  creditSaleBadge: {
    top: 0,
    left: 0,
    show: true,
    size: 12,
    title: "CREDIT SALE",
    name: "Credit Sale Badge",
    identifiyer: "creditSaleBadge",
  },
  creditPendingNotice: {
    top: 0,
    left: 0,
    show: true,
    size: 10,
    title: "Pending Notice",
    name: "Credit Pending Notice",
    identifiyer: "creditPendingNotice",
  },
  paymentDetaiils: {
    top: 300,
    left: 2,
    show: true,
    size: 295,
    title: "Payment detailes",
    name: "payment Details Table",
    identifiyer: "paymentDetaiils",
  },
  changeText: {
    top: 360,
    left: 2,
    show: true,
    size: 13,
    title: "Change",
    name: "Change Text",
    identifiyer: "changeText",
  },
  change: {
    top: 360,
    left: 260,
    show: true,
    size: 13,
    title: "200.00",
    name: "Change Amount",
    identifiyer: "change",
  },
  changeamountText: {
    top: 375,
    left: 2,
    show: true,
    size: 13,
    title: "Change In Cash",
    name: "Change In cash Text",
    identifiyer: "changeamountText",
  },
  changeamount: {
    top: 375,
    left: 260,
    show: true,
    size: 13,
    title: "100.00",
    name: "Change In Cash Amount",
    identifiyer: "changeamount",
  },
  horizontallineone: {
    top: 135,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 1",
    identifiyer: "horizontallineone",
  },
  horizontallinetwo: {
    top: 172,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 2",
    identifiyer: "horizontallinetwo",
  },
  horizontallinethree: {
    top: 240,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 3",
    identifiyer: "horizontallinethree",
  },
  horizontallinefour: {
    top: 243,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 4",
    identifiyer: "horizontallinefour",
  },
  horizontallinefive: {
    top: 352,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 5",
    identifiyer: "horizontallinefive",
  },
  horizontallinesix: {
    top: 395,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 6",
    identifiyer: "horizontallinesix",
  },
  horizontallineseven: {
    top: 465,
    left: 0,
    show: true,
    size: 550,
    name: "Horizondal Line 6",
    identifiyer: "horizontallineseven",
  },
  massage: {
    top: 425,
    left: 100,
    show: true,
    size: 15,
    name: "massage",
    identifiyer: "massage",
  },
  promotion: {
    top: 456,
    left: 175,
    show: true,
    size: 7,
    name: "massage",
    identifiyer: "promotion",
  },
  wish: {
    top: 475,
    left: 70,
    show: true,
    size: 15,
    title: "Thank You! Come Again!",
    name: "Thank You Text",
    identifiyer: "wish",
  },
};

export type PrintElementKey = keyof typeof initialState;
export type PrintSettingTarget = "top" | "left" | "size" | "show";
export type PrintState = typeof initialState;

const initialState = printDefaultState;

interface SetPrintPayload {
  name: PrintElementKey;
  target: PrintSettingTarget;
  value: any;
}

const printSlice = createSlice({
  name: "print",
  initialState,
  reducers: {
    setPrintAction: (state, action: PayloadAction<SetPrintPayload>) => {
      const { name, target, value } = action.payload;

      if (!(state as any)[name]) {
        (state as any)[name] = { ...(printDefaultState as any)[name] };
      }

      (state[name] as any)[target] = value;
    },
  },
});

export const { setPrintAction } = printSlice.actions;
export default printSlice.reducer;
